import {Directive, ElementRef, HostListener} from '@angular/core';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

/** Shows the element's own text in a tooltip while that text is clipped, and nothing once it fits. Pair it with
 * `text-truncate`, or anything else that clips text, so the user can still read what was cut off. The check runs on
 * every hover rather than once, because the space the text has to fit in changes when a column is resized and when
 * the responsive breakpoints move. */
@Directive({
  selector: '[appTooltipWhenTruncated]',
  hostDirectives: [NgbTooltip]
})
export class TooltipWhenTruncatedDirective {

  constructor(private host: ElementRef<HTMLElement>, private tooltip: NgbTooltip) {
    // The tooltip is only wanted once the text is measured as clipped, so take the hover triggers off the tooltip
    // itself and open it from the handlers below instead.
    tooltip.triggers = 'manual';
    // Table cells hide their overflow, so a tooltip rendered inside one would be clipped along with the text it
    // is there to reveal.
    tooltip.container = 'body';
    // Lifts the tooltip's width cap so a long value stays on one line rather than wrapping into a narrow block.
    tooltip.tooltipClass = 'auto-width-tooltip';
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const element = this.host.nativeElement;
    if (element.scrollWidth > element.offsetWidth) {
      this.tooltip.ngbTooltip = element.textContent?.trim() ?? '';
      this.tooltip.open();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.tooltip.isOpen()) {
      this.tooltip.close();
    }
  }
}
